var map = {
	"./ar/alt-tags.json": [
		13886,
		"src_i18n_translations_ar_alt-tags_json"
	],
	"./ar/assets.json": [
		16756,
		"src_i18n_translations_ar_assets_json"
	],
	"./ar/common.json": [
		19048,
		"src_i18n_translations_ar_common_json"
	],
	"./ar/exchange.json": [
		19516,
		"src_i18n_translations_ar_exchange_json"
	],
	"./ar/farms.json": [
		3110,
		"src_i18n_translations_ar_farms_json"
	],
	"./ar/fees.json": [
		3436,
		"src_i18n_translations_ar_fees_json"
	],
	"./ar/glossary.json": [
		64077,
		"src_i18n_translations_ar_glossary_json"
	],
	"./ar/header.json": [
		40092,
		"src_i18n_translations_ar_header_json"
	],
	"./ar/home.json": [
		83862,
		"src_i18n_translations_ar_home_json"
	],
	"./ar/liquidity.json": [
		26447,
		"src_i18n_translations_ar_liquidity_json"
	],
	"./ar/orders.json": [
		8960,
		"src_i18n_translations_ar_orders_json"
	],
	"./ar/portfolio.json": [
		14911,
		"src_i18n_translations_ar_portfolio_json"
	],
	"./ar/queue.json": [
		31988,
		"src_i18n_translations_ar_queue_json"
	],
	"./ar/wallet.json": [
		18720,
		"src_i18n_translations_ar_wallet_json"
	],
	"./ar/warnings.json": [
		72360,
		"src_i18n_translations_ar_warnings_json"
	],
	"./de/alt-tags.json": [
		54690,
		"src_i18n_translations_de_alt-tags_json"
	],
	"./de/assets.json": [
		86176,
		"src_i18n_translations_de_assets_json"
	],
	"./de/common.json": [
		36076,
		"src_i18n_translations_de_common_json"
	],
	"./de/exchange.json": [
		74328,
		"src_i18n_translations_de_exchange_json"
	],
	"./de/farms.json": [
		1114,
		"src_i18n_translations_de_farms_json"
	],
	"./de/fees.json": [
		64864,
		"src_i18n_translations_de_fees_json"
	],
	"./de/glossary.json": [
		70561,
		"src_i18n_translations_de_glossary_json"
	],
	"./de/header.json": [
		45776,
		"src_i18n_translations_de_header_json"
	],
	"./de/home.json": [
		9658,
		"src_i18n_translations_de_home_json"
	],
	"./de/liquidity.json": [
		76563,
		"src_i18n_translations_de_liquidity_json"
	],
	"./de/orders.json": [
		10068,
		"src_i18n_translations_de_orders_json"
	],
	"./de/portfolio.json": [
		42579,
		"src_i18n_translations_de_portfolio_json"
	],
	"./de/queue.json": [
		99736,
		"src_i18n_translations_de_queue_json"
	],
	"./de/wallet.json": [
		6660,
		"src_i18n_translations_de_wallet_json"
	],
	"./de/warnings.json": [
		41364,
		"src_i18n_translations_de_warnings_json"
	],
	"./en/alt-tags.json": [
		62758,
		"src_i18n_translations_en_alt-tags_json"
	],
	"./en/assets.json": [
		83420,
		"src_i18n_translations_en_assets_json"
	],
	"./en/common.json": [
		92192,
		"src_i18n_translations_en_common_json"
	],
	"./en/error-fallback.json": [
		73066,
		"src_i18n_translations_en_error-fallback_json"
	],
	"./en/exchange.json": [
		49940,
		"src_i18n_translations_en_exchange_json"
	],
	"./en/farms.json": [
		96942,
		"src_i18n_translations_en_farms_json"
	],
	"./en/fees.json": [
		39700,
		"src_i18n_translations_en_fees_json"
	],
	"./en/first-visits.json": [
		9419,
		"src_i18n_translations_en_first-visits_json"
	],
	"./en/glossary.json": [
		34917,
		"src_i18n_translations_en_glossary_json"
	],
	"./en/header.json": [
		56980,
		"src_i18n_translations_en_header_json"
	],
	"./en/help-center.json": [
		55936,
		"src_i18n_translations_en_help-center_json"
	],
	"./en/home.json": [
		15374,
		"src_i18n_translations_en_home_json"
	],
	"./en/joyride.json": [
		82963,
		"src_i18n_translations_en_joyride_json"
	],
	"./en/liquidity.json": [
		13687,
		"src_i18n_translations_en_liquidity_json"
	],
	"./en/loading.json": [
		18611,
		"src_i18n_translations_en_loading_json"
	],
	"./en/news.json": [
		6694,
		"src_i18n_translations_en_news_json"
	],
	"./en/not-found.json": [
		88427,
		"src_i18n_translations_en_not-found_json"
	],
	"./en/orders.json": [
		24216,
		"src_i18n_translations_en_orders_json"
	],
	"./en/portfolio.json": [
		8756,
		"src_i18n_translations_en_portfolio_json"
	],
	"./en/queue.json": [
		32831,
		"src_i18n_translations_en_queue_json"
	],
	"./en/taste-test.json": [
		6883,
		"src_i18n_translations_en_taste-test_json"
	],
	"./en/transactions.json": [
		61492,
		"src_i18n_translations_en_transactions_json"
	],
	"./en/wallet.json": [
		91272,
		"src_i18n_translations_en_wallet_json"
	],
	"./en/warnings.json": [
		79840,
		"src_i18n_translations_en_warnings_json"
	],
	"./es/alt-tags.json": [
		85775,
		"src_i18n_translations_es_alt-tags_json"
	],
	"./es/assets.json": [
		78929,
		"src_i18n_translations_es_assets_json"
	],
	"./es/common.json": [
		21857,
		"src_i18n_translations_es_common_json"
	],
	"./es/exchange.json": [
		27821,
		"src_i18n_translations_es_exchange_json"
	],
	"./es/farms.json": [
		6581,
		"src_i18n_translations_es_farms_json"
	],
	"./es/fees.json": [
		35409,
		"src_i18n_translations_es_fees_json"
	],
	"./es/glossary.json": [
		9924,
		"src_i18n_translations_es_glossary_json"
	],
	"./es/header.json": [
		95077,
		"src_i18n_translations_es_header_json"
	],
	"./es/home.json": [
		53843,
		"src_i18n_translations_es_home_json"
	],
	"./es/liquidity.json": [
		38840,
		"src_i18n_translations_es_liquidity_json"
	],
	"./es/orders.json": [
		23737,
		"src_i18n_translations_es_orders_json"
	],
	"./es/portfolio.json": [
		59876,
		"src_i18n_translations_es_portfolio_json"
	],
	"./es/queue.json": [
		46699,
		"src_i18n_translations_es_queue_json"
	],
	"./es/wallet.json": [
		58133,
		"src_i18n_translations_es_wallet_json"
	],
	"./es/warnings.json": [
		69821,
		"src_i18n_translations_es_warnings_json"
	],
	"./fr/alt-tags.json": [
		54835,
		"src_i18n_translations_fr_alt-tags_json"
	],
	"./fr/assets.json": [
		22813,
		"src_i18n_translations_fr_assets_json"
	],
	"./fr/common.json": [
		98421,
		"src_i18n_translations_fr_common_json"
	],
	"./fr/exchange.json": [
		30761,
		"src_i18n_translations_fr_exchange_json"
	],
	"./fr/farms.json": [
		45129,
		"src_i18n_translations_fr_farms_json"
	],
	"./fr/fees.json": [
		6421,
		"src_i18n_translations_fr_fees_json"
	],
	"./fr/glossary.json": [
		24744,
		"src_i18n_translations_fr_glossary_json"
	],
	"./fr/header.json": [
		9849,
		"src_i18n_translations_fr_header_json"
	],
	"./fr/home.json": [
		9959,
		"src_i18n_translations_fr_home_json"
	],
	"./fr/liquidity.json": [
		54492,
		"src_i18n_translations_fr_liquidity_json"
	],
	"./fr/orders.json": [
		96189,
		"src_i18n_translations_fr_orders_json"
	],
	"./fr/portfolio.json": [
		63896,
		"src_i18n_translations_fr_portfolio_json"
	],
	"./fr/queue.json": [
		15855,
		"src_i18n_translations_fr_queue_json"
	],
	"./fr/wallet.json": [
		68041,
		"src_i18n_translations_fr_wallet_json"
	],
	"./fr/warnings.json": [
		98857,
		"src_i18n_translations_fr_warnings_json"
	],
	"./it/alt-tags.json": [
		38780,
		"src_i18n_translations_it_alt-tags_json"
	],
	"./it/assets.json": [
		67342,
		"src_i18n_translations_it_assets_json"
	],
	"./it/common.json": [
		35878,
		"src_i18n_translations_it_common_json"
	],
	"./it/exchange.json": [
		69078,
		"src_i18n_translations_it_exchange_json"
	],
	"./it/farms.json": [
		8380,
		"src_i18n_translations_it_farms_json"
	],
	"./it/fees.json": [
		46914,
		"src_i18n_translations_it_fees_json"
	],
	"./it/glossary.json": [
		45215,
		"src_i18n_translations_it_glossary_json"
	],
	"./it/header.json": [
		60342,
		"src_i18n_translations_it_header_json"
	],
	"./it/home.json": [
		16928,
		"src_i18n_translations_it_home_json"
	],
	"./it/liquidity.json": [
		37897,
		"src_i18n_translations_it_liquidity_json"
	],
	"./it/orders.json": [
		52262,
		"src_i18n_translations_it_orders_json"
	],
	"./it/portfolio.json": [
		7389,
		"src_i18n_translations_it_portfolio_json"
	],
	"./it/queue.json": [
		87766,
		"src_i18n_translations_it_queue_json"
	],
	"./it/wallet.json": [
		61202,
		"src_i18n_translations_it_wallet_json"
	],
	"./it/warnings.json": [
		13086,
		"src_i18n_translations_it_warnings_json"
	],
	"./ja/alt-tags.json": [
		13796,
		"src_i18n_translations_ja_alt-tags_json"
	],
	"./ja/assets.json": [
		29590,
		"src_i18n_translations_ja_assets_json"
	],
	"./ja/common.json": [
		31198,
		"src_i18n_translations_ja_common_json"
	],
	"./ja/exchange.json": [
		98894,
		"src_i18n_translations_ja_exchange_json"
	],
	"./ja/farms.json": [
		29188,
		"src_i18n_translations_ja_farms_json"
	],
	"./ja/fees.json": [
		47914,
		"src_i18n_translations_ja_fees_json"
	],
	"./ja/glossary.json": [
		43767,
		"src_i18n_translations_ja_glossary_json"
	],
	"./ja/header.json": [
		83278,
		"src_i18n_translations_ja_header_json"
	],
	"./ja/home.json": [
		58584,
		"src_i18n_translations_ja_home_json"
	],
	"./ja/liquidity.json": [
		47345,
		"src_i18n_translations_ja_liquidity_json"
	],
	"./ja/orders.json": [
		9950,
		"src_i18n_translations_ja_orders_json"
	],
	"./ja/portfolio.json": [
		28933,
		"src_i18n_translations_ja_portfolio_json"
	],
	"./ja/queue.json": [
		86766,
		"src_i18n_translations_ja_queue_json"
	],
	"./ja/wallet.json": [
		87770,
		"src_i18n_translations_ja_wallet_json"
	],
	"./ja/warnings.json": [
		13078,
		"src_i18n_translations_ja_warnings_json"
	],
	"./nl/alt-tags.json": [
		55801,
		"src_i18n_translations_nl_alt-tags_json"
	],
	"./nl/assets.json": [
		61583,
		"src_i18n_translations_nl_assets_json"
	],
	"./nl/common.json": [
		55323,
		"src_i18n_translations_nl_common_json"
	],
	"./nl/exchange.json": [
		66811,
		"src_i18n_translations_nl_exchange_json"
	],
	"./nl/farms.json": [
		8327,
		"src_i18n_translations_nl_farms_json"
	],
	"./nl/fees.json": [
		5227,
		"src_i18n_translations_nl_fees_json"
	],
	"./nl/glossary.json": [
		61626,
		"src_i18n_translations_nl_glossary_json"
	],
	"./nl/header.json": [
		97995,
		"src_i18n_translations_nl_header_json"
	],
	"./nl/home.json": [
		11193,
		"src_i18n_translations_nl_home_json"
	],
	"./nl/liquidity.json": [
		45998,
		"src_i18n_translations_nl_liquidity_json"
	],
	"./nl/orders.json": [
		95611,
		"src_i18n_translations_nl_orders_json"
	],
	"./nl/portfolio.json": [
		2910,
		"src_i18n_translations_nl_portfolio_json"
	],
	"./nl/queue.json": [
		32785,
		"src_i18n_translations_nl_queue_json"
	],
	"./nl/wallet.json": [
		12843,
		"src_i18n_translations_nl_wallet_json"
	],
	"./nl/warnings.json": [
		40167,
		"src_i18n_translations_nl_warnings_json"
	],
	"./pt/alt-tags.json": [
		47603,
		"src_i18n_translations_pt_alt-tags_json"
	],
	"./pt/assets.json": [
		44669,
		"src_i18n_translations_pt_assets_json"
	],
	"./pt/common.json": [
		54453,
		"src_i18n_translations_pt_common_json"
	],
	"./pt/exchange.json": [
		43465,
		"src_i18n_translations_pt_exchange_json"
	],
	"./pt/farms.json": [
		74537,
		"src_i18n_translations_pt_farms_json"
	],
	"./pt/fees.json": [
		97077,
		"src_i18n_translations_pt_fees_json"
	],
	"./pt/glossary.json": [
		50536,
		"src_i18n_translations_pt_glossary_json"
	],
	"./pt/header.json": [
		64953,
		"src_i18n_translations_pt_header_json"
	],
	"./pt/home.json": [
		30215,
		"src_i18n_translations_pt_home_json"
	],
	"./pt/liquidity.json": [
		2108,
		"src_i18n_translations_pt_liquidity_json"
	],
	"./pt/orders.json": [
		72541,
		"src_i18n_translations_pt_orders_json"
	],
	"./pt/portfolio.json": [
		54040,
		"src_i18n_translations_pt_portfolio_json"
	],
	"./pt/queue.json": [
		6767,
		"src_i18n_translations_pt_queue_json"
	],
	"./pt/wallet.json": [
		51817,
		"src_i18n_translations_pt_wallet_json"
	],
	"./pt/warnings.json": [
		29929,
		"src_i18n_translations_pt_warnings_json"
	],
	"./ru/alt-tags.json": [
		10976,
		"src_i18n_translations_ru_alt-tags_json"
	],
	"./ru/assets.json": [
		16362,
		"src_i18n_translations_ru_assets_json"
	],
	"./ru/common.json": [
		85226,
		"src_i18n_translations_ru_common_json"
	],
	"./ru/exchange.json": [
		13074,
		"src_i18n_translations_ru_exchange_json"
	],
	"./ru/farms.json": [
		87040,
		"src_i18n_translations_ru_farms_json"
	],
	"./ru/fees.json": [
		38310,
		"src_i18n_translations_ru_fees_json"
	],
	"./ru/glossary.json": [
		10179,
		"src_i18n_translations_ru_glossary_json"
	],
	"./ru/header.json": [
		99354,
		"src_i18n_translations_ru_header_json"
	],
	"./ru/home.json": [
		30164,
		"src_i18n_translations_ru_home_json"
	],
	"./ru/liquidity.json": [
		58301,
		"src_i18n_translations_ru_liquidity_json"
	],
	"./ru/orders.json": [
		23370,
		"src_i18n_translations_ru_orders_json"
	],
	"./ru/portfolio.json": [
		88097,
		"src_i18n_translations_ru_portfolio_json"
	],
	"./ru/queue.json": [
		38154,
		"src_i18n_translations_ru_queue_json"
	],
	"./ru/wallet.json": [
		64982,
		"src_i18n_translations_ru_wallet_json"
	],
	"./ru/warnings.json": [
		76042,
		"src_i18n_translations_ru_warnings_json"
	],
	"./th/alt-tags.json": [
		23971,
		"src_i18n_translations_th_alt-tags_json"
	],
	"./th/assets.json": [
		8717,
		"src_i18n_translations_th_assets_json"
	],
	"./th/common.json": [
		69349,
		"src_i18n_translations_th_common_json"
	],
	"./th/exchange.json": [
		45465,
		"src_i18n_translations_th_exchange_json"
	],
	"./th/farms.json": [
		72025,
		"src_i18n_translations_th_farms_json"
	],
	"./th/fees.json": [
		40869,
		"src_i18n_translations_th_fees_json"
	],
	"./th/glossary.json": [
		81336,
		"src_i18n_translations_th_glossary_json"
	],
	"./th/header.json": [
		4137,
		"src_i18n_translations_th_header_json"
	],
	"./th/home.json": [
		59799,
		"src_i18n_translations_th_home_json"
	],
	"./th/liquidity.json": [
		46796,
		"src_i18n_translations_th_liquidity_json"
	],
	"./th/orders.json": [
		54349,
		"src_i18n_translations_th_orders_json"
	],
	"./th/portfolio.json": [
		1320,
		"src_i18n_translations_th_portfolio_json"
	],
	"./th/queue.json": [
		70668,
		"src_i18n_translations_th_queue_json"
	],
	"./th/wallet.json": [
		96313,
		"src_i18n_translations_th_wallet_json"
	],
	"./th/warnings.json": [
		58617,
		"src_i18n_translations_th_warnings_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 85429;
module.exports = webpackAsyncContext;